function containsNonEmailCharacters(email: string): boolean {
  if (email.charAt(0) === '.') return true;
  if (email.charAt(0) === '+') return true;
  if (email.includes('..')) return true;
  if (email.includes(' ')) return true;
  return false;
}

export default containsNonEmailCharacters;
